/*global require*/
import React, { Component, PropTypes } from 'react';
import styles from './Styles';
import { taskTypes } from 'Constants';
import RadioTask from './RadioTask';
import CheckBoxTask from './CheckBoxTask';
import TextTask from './TextTask';

const taskComponents = {
  1: RadioTask,
  2: CheckBoxTask,
  4: TextTask,
  7: TextTask
};

export default class Task extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isTaskOpen: false
    };
  }

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  getStatusForChoice() {
    if (!this.props.taskResults || this.props.taskResults.length === 0) {
      return 'incomplete';
    } else {
      let correct = true;
      const lastResult = this.props.taskResults[
        this.props.taskResults.length - 1
      ];
      const values = lastResult.body.value;
      const correctResponse =
        (this.props.correctResponse && this.props.correctResponse.value) || [];
      if (values && values.length !== correctResponse.length) {
        return 'incorrect';
      } else {
        correctResponse.forEach(value => {
          if (values.indexOf(value) < 0) {
            correct = false;
          }
        });
        return correct ? 'correct' : 'incorrect';
      }
    }
  }

  getStatusForText() {
    if (!this.props.taskResults || this.props.taskResults.length === 0) {
      return 'incomplete';
    } else {
      const lastResult = this.props.taskResults[
        this.props.taskResults.length - 1
      ];
      const { feedback } = lastResult;
      if (feedback) {
        if (feedback.grade === 0) {
          return 'incorrect';
        } else if (feedback.grade === 1) {
          return 'correct';
        } else if (feedback.grade === -1) {
          return 'incomplete';
        }
      } else {
        return 'incomplete';
      }
    }
  }

  expandTask() {
    this.setState({isTaskOpen: !this.state.isTaskOpen})
  }

  getStatus() {
    let type = this.props.type || taskTypes.SINGLE_CHOICE;
    if (type === taskTypes.SINGLE_CHOICE || type === taskTypes.MULTI_CHOICE) {
      return this.getStatusForChoice();
    } else if (type === taskTypes.TEXT) {
      return this.getStatusForText();
    }
  }

  getStyle() {
    let status = this.getStatus();
    return Object.assign({}, styles.root, styles['incomplete'], {cursor: 'pointer'});
  }

  render() {
    let { type, canAnswer, settings, reader, isQuiz, ...other } = this.props;

    // "showTaskResultOnAnswer" is Jägarförbundet-only functionality,
    // which only should work on /course page.
    const isOnCoursePage = window.location.pathname.includes('/course/');
    const showTaskResultOnAnswer =
      isOnCoursePage &&
      settings &&
      settings.list &&
      settings.list.features &&
      settings.list.features.showTaskResultOnAnswer === true;

    if (typeof canAnswer === 'undefined') {
      canAnswer = true;
    }

    type = type || taskTypes.SINGLE_CHOICE;
    let SpecializedTask = taskComponents[type];
    let task = (
      <SpecializedTask
        showTaskResultOnAnswer={showTaskResultOnAnswer}
        isQuiz={isQuiz}
        canAnswer={canAnswer}
        reader={reader}
        {...other}
      />
    );

    return (
      <div id={`task-${this.props.id}`} onClick={!this.props.reader && this.props.taskResults && this.props.taskResults.length === 0 ? () => this.expandTask() : null} style={this.getStyle()}>
        {task}
        {
          this.state.isTaskOpen ?
            <div style={{
              height: 150,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: 25,
              textAlign: 'center'
            }}>
              {this.context.getIntlMessage('tasks.noInfo')}
            </div>
            :
            null
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Task/Task.js